import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import { motion } from "motion/react";
import { createElement } from "react";
import { IconType } from "react-icons";
import { TbBriefcase, TbClock } from "react-icons/tb";

import DriverAvatar from "@/components/DriverAvatar";
import { getTotalWorkDuration } from "@/helpers/date";
import { useUsersLifecycleInfo } from "@/stores/use-users-table";

function LifecycleStatItem(stat: { title: string; count: number | string; delay?: number; icon: IconType }) {
    const { title, count, delay = 0, icon } = stat;
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay }}
            className="  p-3 flex items-center gap-3"
        >
            <div
                className={`inline-flex shrink-0 h-10 w-10 items-center justify-center rounded border border-gray-200/50  transition-all duration-300`}
            >
                {createElement(icon, { color: grey[700], size: 24 })}
            </div>

            <div className="relative w-full grow">
                <div>
                    <p className="text-sm font-medium text-gray-500  block">{title}</p>
                    <h3 className="text-xl font-semibold text-gray-800 dark:text-white/90">{count}</h3>
                </div>
            </div>
        </motion.div>
    );
}

function UserLifecycleHeader() {
    const userLifecycleInfo = useUsersLifecycleInfo();
    if (!userLifecycleInfo) return null;
    const totalWorkDuration = getTotalWorkDuration(userLifecycleInfo.lifecycles);
    return (
        <div className=" rounded-lg  mb-4">
            <div className=" flex items-center py-2">
                <DriverAvatar
                    name={userLifecycleInfo.name}
                    userType={userLifecycleInfo.userType}
                    isDeleted={userLifecycleInfo.isDeleted}
                    avatar={true}
                    className="text-base"
                    iconSize={20}
                />
            </div>
            <div className=" grid grid-cols-[1fr,1px,1fr] gap-6 border rounded-lg ">
                <LifecycleStatItem title="Toplam Çalışma Süresi" count={totalWorkDuration} icon={TbClock} />
                <Divider orientation="vertical" flexItem />
                <LifecycleStatItem
                    title="Toplam Çalışma Dönemi"
                    count={userLifecycleInfo.lifecycles.length}
                    icon={TbBriefcase}
                />
            </div>
        </div>
    );
}

export default UserLifecycleHeader;
